import { Component, OnDestroy, OnInit } from '@angular/core';

import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { AmplificationStatusAPIEnum } from '../../../../../api/distributions/enum/amplification-status-api.enum';
import { WireRegion } from '../../../../../api/wire/enums/wire-region.enum';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { ConfigService } from '../../../../../Core/Config/services/config.service';
import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { userPermissionsEnum } from '../../../../../Core/Users/enums/user-permissions.enum';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { AmplificationStatusEnum } from '../../../enums/amplification-status.enum';
import { DistributionModel } from '../../../models/distribution.model';
import { ScheduleType } from '../.././../../../Common/Forms/components/DeliveryScheduleInput/models/delivery-schedule';



@Component({
    selector: 'agpr-post-distribution-amplify-dialog',
    templateUrl: './post-distribution-amplify-dialog.component.html',
    styleUrls: ['./post-distribution-amplify-dialog.component.scss'],
    standalone: false
})
export class PostDistributionAmplifyDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {
    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverity = messageSeverityEnum;
    readonly wireRegionEnum = WireRegion;

    private subscriptions: Subscription[] = [];

    loading = false;
    distribution: DistributionModel;
    scheduledDate: Date;
    userHasNewsroomPermission = false;
    userHasNewswirePermission = false;
    userHasBoostPermission = false;
    showBoost: boolean = true;
    doBoost = false;
    dateFormat: string;
    isImmediate = false;

    constructor(
        public coreDialogService: CoreDialogService,
        private messageService: MessageService,
        private currentUserService: CurrentUserStateService,
        private configService: ConfigService,
        private distributionService: DistributionService
    ) {
        super(coreDialogService, 'PostDistributionAmplifyDialogComponent');
    }

    ngOnInit() {
        this.subscriptions.push(
            this.distributionService.getFocusedResource().pipe(
                switchMap(distribution => {
                    this.distribution = distribution;
                    this.isImmediate = (this.distribution.sentNow || this.distribution.deliverySchedule?.scheduleType === ScheduleType.immediate);
                    if (!this.isImmediate) {
                        this.scheduledDate = new Date(this.distribution.deliverySchedule?.scheduledDateUTC);
                    }
                    return this.distributionService.getDistributionPostOptions(this.distribution.id);
                }),
                tap(options => {
                    if (options.includes(AmplificationStatusAPIEnum.ONLINE_BOOST)) {
                        this.showBoost = false;
                    }
                })
            ).subscribe(),
            this.currentUserService.hasAllPermissions([userPermissionsEnum.newswireplus]).subscribe(hasNewswire => {
                this.userHasNewswirePermission = hasNewswire;
            }),
            this.currentUserService.hasAllPermissions([userPermissionsEnum.newsroom]).subscribe(hasNewsroom => {
                this.userHasNewsroomPermission = hasNewsroom;
            }),
            this.currentUserService.hasAllPermissions([userPermissionsEnum.advancedTargeting]).subscribe(hasTargeting => {
                this.userHasBoostPermission = !this.configService.getConfig().brandGUID && hasTargeting;
            }),
            this.currentUserService.getPreferences().subscribe(prefs => {
                this.dateFormat = prefs.getDateFormatString(false, true, true);
            }),
        );
    }

    setAmplifications() {
        if (this.distribution?.amplification?.length > 0) {
            if (!this.distribution.amplification.includes(AmplificationStatusEnum.ONLINE_BOOST)) {
                this.distribution.amplification.push(AmplificationStatusEnum.ONLINE_BOOST);
            }
        } else {
            this.distribution.amplification = [AmplificationStatusEnum.ONLINE_BOOST];
        }

        this.distributionService.setDistributionPostOptions(this.distribution.id, [AmplificationStatusAPIEnum.ONLINE_BOOST]).subscribe({
            next: () => {
                this.messageService.add({
                    severity: messageSeverityEnum.success,
                    summary: 'Discover.onlineBoost.growlMessage.heading',
                    detail: 'Discover.onlineBoost.growlMessage.text'
                });
                this.distributionService.setFocusedDistribution(this.distribution);
            },
            error: () => {
                this.messageService.add({
                    severity: messageSeverityEnum.error,
                    summary: 'Discover.onlineBoost.error.growlMessage.heading',
                    detail: 'Discover.onlineBoost.error.growlMessage.text'
                });
            }
        });
        this.closeDialog();
    }

    close() {
        this.closeDialog();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

}
